import React from 'react'

import {
  Container,
  Title,
  Table,
  THeader,
  HeaderCell,
  TBody,
  Index,
  TRow,
  Cell,
} from './styles'
import { ProductRankingProps } from './props'
import { numberToCurrency } from '../../../../helpers/helper-currency'

const ProductsRanking = ({ data }: ProductRankingProps) => (
  <Container>
    <Title>Mais vendidos</Title>

    <Table>
      <THeader>
        <HeaderCell>Produto</HeaderCell>
        <HeaderCell>Valor</HeaderCell>
        <HeaderCell>Qtd. vendas</HeaderCell>
      </THeader>
      <TBody>
        {
          data.map((item, index) => (
            <TRow>
              <Index>{String(index + 1).padStart(2, '0')}</Index>
              <Cell style={{ color: '#252A31' }}>{item.name}</Cell>
              <Cell>{numberToCurrency(item.price)}</Cell>
              <Cell>{item.amount}</Cell>
            </TRow>
          ))
        }
      </TBody>
    </Table>
  </Container>
)

export default ProductsRanking
